import { render } from "./Donations.vue?vue&type=template&id=7cd9a909&scoped=true"
const script = {}

import "./Donations.vue?vue&type=style&index=0&id=7cd9a909&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7cd9a909"

export default script